



















































































































import {AgGridVue} from 'ag-grid-vue'
import TablesList from '@/views/table/TablesList.vue'
import {Component, Vue} from 'vue-property-decorator'
import {gMutate, gQuery} from '@/services/graphql'
import {TablesGQL} from '@dynamoit/shared/src/queries/TablesGQL'
import {
    DataForTableAndProfile,
    DataForTableAndProfileVariables
} from '@dynamoit/shared/generated/DataForTableAndProfile'
import {Route} from 'vue-router'
import {
    CellClassParams,
    ColDef,
    GridOptions,
    RowDoubleClickedEvent,
    SelectionChangedEvent,
    ViewportChangedEvent
} from "ag-grid-community";
import AgGridLoadingOverlay from '@/components/AgGridLoadingOverlay.vue'
import {DescribeTable, DescribeTableVariables} from '@dynamoit/shared/generated/DescribeTable'
import AgGridFilterRenderer from '@/components/AgGridFilterRenderer.vue'
import AgGridClearableFloatFilter from '@/components/AgGridClearableFloatFilter.vue'
import TableFilter from './TableFilter.vue'
import {Criterion, Operation} from '@dynamoit/shared/generated/globalTypes'
import {TableDescription} from '@/views/table/constants'
import {Criteria, QueryModel, TypesModel} from "@/types";
import EditDocument from './EditDocument.vue'
import DiffDocuments from './DiffDocuments.vue'
import {isArray, queryModelToQueryInput} from '@/utils/utils'
import {SaveDocuments, SaveDocumentsVariables} from '@dynamoit/shared/generated/SaveDocuments'
import colors from 'vuetify/lib/util/colors'

Component.registerHooks([
    'beforeRouteUpdate'
])

@Component({
    components: {
        AgGridVue, TablesList, TableFilter, EditDocument, DiffDocuments
    }
})
export default class Table extends Vue {

    showMenu = true
    deleteConfirmShow = false
    rows: any[] = []
    tableDescription: TableDescription | null = null

    lastEvaluatedKey: any | null = null
    loading = false
    selectedRows: any[] = []

    editDocument: any | null = null
    compareDocuments: any[] | null = null

    fileSaving = false

    queryModel: QueryModel = {
        hash: '',
        criteria: {}
    }

    typesModel: TypesModel = {}

    gridOptions: GridOptions = {
        api: null,
        columnApi: null,
        suppressRowClickSelection: true,
        defaultColDef: {
            sortable: true,
            filter: true,
            suppressMenu: true,
            resizable: true,
            floatingFilter: true,
            floatingFilterComponent: 'clearableFilter',
            floatingFilterComponentParams: {
                suppressFilterButton: true
            },
            filterParams: {
                filterOptions: [
                    {
                        displayKey: 'alwaysTrue',
                        displayName: 'Always true',
                        test: () => true
                    }
                ]
            }
        },
        frameworkComponents: {
            customLoadingOverlay: AgGridLoadingOverlay,
            clearableFilter: AgGridClearableFloatFilter
        },
        loadingOverlayComponent: 'customLoadingOverlay'
    }

    distinctFilter = (value: any, index: number, array: any[]): boolean => array.indexOf(value) === index

    header: ColDef[] = []

    highlighter: { [colId: string]: { [value: string]: string } } = {}

    get profile() {
        return this.$route.params.profile
    }

    get tableName() {
        return this.$route.params.tableName
    }

    get count() {
        return this.rows?.length || 0
    }

    get totalCount() {
        return this.tableDescription?.ItemCount || 0
    }

    onAddClick() {
        this.editDocument = {
            [this.queryModel.hash]: '',
            ...this.queryModel.range ? {[this.queryModel.range]: ''} : {}
        }
    }

    async onDeleteClick() {
        if (this.selectedRows.length > 0) {
            try {
                await gMutate<SaveDocuments, SaveDocumentsVariables>(TablesGQL.DELETE_DOCUMENTS, {
                    tableName: this.tableName,
                    profileId: this.profile,
                    documents: this.selectedRows.map(_ => JSON.stringify({
                        [this.queryModel.hash]: _[this.queryModel.hash],
                        ...this.queryModel.range ? {[this.queryModel.range]: _[this.queryModel.range]} : {}
                    }))
                })
                this.onDocumentSaved()
            } catch (e) {
                this.$store.commit('setErrorMessage', e.message)
            }
        }
        this.deleteConfirmShow = false
    }

    async onTableFilterChange(criteria: Criteria) {
        this.queryModel.criteria = criteria
        this.lastEvaluatedKey = null
        await this.loadData(this.profile, this.tableName, false)
        this.selectedRows = []
    }

    async modifiedCriteriaCallback(property: string, value: string | null | undefined) {
        if (value !== null && value !== undefined && value !== '') {
            const criterion: Criterion = this.queryModel.criteria[property] || {
                property,
                operation: Operation.EQUAL,
                value: {
                    data: value
                }
            }
            criterion.value.data = value

            this.queryModel.criteria = {
                ...this.queryModel.criteria,
                [property]: criterion
            }
        } else {
            this.queryModel.criteria = {
                ...Object.values(this.queryModel.criteria)
                    .filter(_ => _.property !== property)
                    .reduce((acc, val) => ({
                        ...acc,
                        [val.property]: val
                    }), {})
            }
        }

        this.lastEvaluatedKey = null
        await this.loadData(this.profile, this.tableName, false)
        this.selectedRows = []
    }

    async onFilterClick(property: string, value: string) {
        this.queryModel.criteria = {
            ...this.queryModel.criteria,
            [property]: {
                property,
                value: {
                    data: value
                },
                operation: Operation.EQUAL
            }
        }

        this.lastEvaluatedKey = null
        await this.loadData(this.profile, this.tableName, false)
        this.selectedRows = []
    }

    onHighlightClick(property: string, value: any) {
        const colorsList = Object.keys(colors).filter(_ => _ !== 'shades');
        const randColorName = colorsList[Math.floor(Math.random() * colorsList.length)]
        this.highlighter[property] = {
            ...this.highlighter[property] || {},
            [`${value}`]: randColorName
        }

        this.gridOptions.api?.refreshCells({
            force: true,
            columns: Object.keys(this.highlighter)
        })
    }

    onCompareDocuments() {
        if (this.selectedRows.length > 1) {
            this.compareDocuments = this.selectedRows.slice(0, 2)
        }
    }

    onEditDocument() {
        if (this.selectedRows.length > 0) {
            this.editDocument = JSON.parse(JSON.stringify(this.selectedRows[0]))
        }
    }

    async onDownloadDocuments() {
        function saveAsJson(fileName: string, data: any[]) {
            const content = JSON.stringify(data, null, 4)
            const a = document.createElement('a');
            const file = new Blob([content], {type: 'application/json'});

            a.href = URL.createObjectURL(file);
            a.download = fileName + '.json';
            a.click();

            URL.revokeObjectURL(a.href);
        }

        if (this.selectedRows.length > 0) {
            saveAsJson(this.tableName, this.selectedRows)
        } else {
            for (; this.lastEvaluatedKey !== null && this.rows.length < 1000;) {
                await this.loadData(this.profile, this.tableName)
            }
            saveAsJson(this.tableName, this.rows)
        }
    }

    async onUploadDocuments(e: Event) {
        const files = (e.target as HTMLInputElement).files

        if (files && files.length > 0) {
            try {
                this.fileSaving = true
                const reader = new FileReader();
                const fileData = await new Promise<any[]>((resolve, reject) => {
                    reader.onload = (event: ProgressEvent<FileReader>) => {
                        if (event.target?.result) {
                            try {
                                resolve(JSON.parse(event.target.result.toString()))
                            } catch (e) {
                                reject(new Error('Can not parse JSON content of the file.'))
                            }
                        } else {
                            resolve([])
                        }
                    }
                    reader.readAsText(files[0])
                })

                if (!isArray(fileData)) {
                    this.$store.commit('setErrorMessage', 'File should contain the list of objects in JSON format')
                }

                if (fileData.length > 0) {
                    await gMutate<SaveDocuments, SaveDocumentsVariables>(TablesGQL.SAVE_DOCUMENTS, {
                        tableName: this.tableName,
                        profileId: this.profile,
                        documents: fileData.map(_ => JSON.stringify(_))
                    })
                    this.onDocumentSaved()
                }
            } catch (e) {
                this.$store.commit('setErrorMessage', e.message)
            } finally {
                this.fileSaving = false
            }
        }
    }

    async onDocumentSaved() {
        this.lastEvaluatedKey = null
        await this.loadData(this.profile, this.tableName, false)
        this.selectedRows = []
    }

    autoSizeColumns() {
        if (this.gridOptions?.columnApi) {
            const ids = (this.gridOptions.columnApi.getAllColumns() || [])
                .filter(_ => _.getColId() !== 'check')
                .map(_ => _.getColId())

            this.gridOptions.columnApi.autoSizeColumns(ids, false);
        }
    }

    updateFilterModel() {
        const model = Object.keys(this.queryModel.criteria).map(field => ({
            [field]: {
                type: 'alwaysTrue',
                filter: this.queryModel.criteria[field].value.data
            }
        })).reduce((acc, val) => ({
            ...acc,
            ...val
        }), {})

        this.$nextTick(() => {
            this.gridOptions.api?.setFilterModel(model)
        })
    }

    async loadData(profileId: string, tableName: string, append = true) {
        try {
            this.loading = true
            this.gridOptions?.api?.showLoadingOverlay()
            const result = await gQuery<DataForTableAndProfile, DataForTableAndProfileVariables>(TablesGQL.DATA_FOR_TABLE_AND_PROFILE, {
                profileId,
                tableName,
                query: queryModelToQueryInput(this.queryModel, this.typesModel),
                lastEvaluatedKey: this.lastEvaluatedKey ? JSON.stringify(this.lastEvaluatedKey) : undefined
            })
            const dynamoResponse = JSON.parse(result.data.dataForTableAndProfile)
            this.rows = [
                ...append ? this.rows : [],
                ...dynamoResponse.Items || []
            ]
            this.lastEvaluatedKey = dynamoResponse.LastEvaluatedKey || null
            this.updateFilterModel()

            this.typesModel = this.rows.flatMap(_ => Object.entries(_))
                .filter(_ => !!_[1])
                .map(_ => ({
                    property: _[0],
                    type: typeof _[1] === 'number' ? 'number' : 'string'
                }))
                .reduce<TypesModel>((acc, val) => ({
                    ...acc,
                    [val.property]: ((!acc[val.property] || acc[val.property] === 'number') && val.type === 'number' ? 'number' : 'string')
                }), {})
        } catch (error) {
            console.log(error)
            if (error.name === 'NotAuthorizedException') {
                this.$router.push({name: 'login'})
            }
            this.rows = []
        } finally {
            this.loading = false
        }
    }

    async loadTableDescription(profileId: string, tableName: string) {
        const result = await gQuery<DescribeTable, DescribeTableVariables>(TablesGQL.DESCRIBE_TABLE, {
            profileId,
            tableName
        })
        this.tableDescription = JSON.parse(result.data.describeTable)

        this.queryModel.hash = this.tableDescription?.KeySchema.filter(_ => _.KeyType === "HASH").map(_ => _.AttributeName).find(_ => !!_) || ''
        this.queryModel.range = this.tableDescription?.KeySchema.filter(_ => _.KeyType === "RANGE").map(_ => _.AttributeName).find(_ => !!_) || undefined
    }

    buildHeader() {
        if (this.header.length === 0) {
            this.header.push({
                headerName: '',
                field: 'check',
                pinned: 'left',
                width: 35,
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
                checkboxSelection: true,
                filter: false,
                resizable: false,
                sortable: false
            })
        }
        if (!this.rows || !this.tableDescription) {
            return
        }

        const columnBuilder = (field: string): ColDef => ({
            field,
            flex: 1,
            minWidth: 100,
            floatingFilterComponentParams: {
                queryModel: this.queryModel,
                modifiedCriteriaCallback: this.modifiedCriteriaCallback
            },
            cellRendererFramework: AgGridFilterRenderer,
            cellRendererParams: {
                onFilterClickCallback: this.onFilterClick,
                onHighlightClickCallback: this.onHighlightClick
            },
            cellClass: (params: CellClassParams) => {
                if (this.highlighter[field]?.[`${params.value}`]) {
                    return ['pr-0', this.highlighter[field][`${params.value}`], ' lighten-4']
                }
                return 'pr-0'
            }
        })

        const schemaHeader: ColDef[] = this.tableDescription.KeySchema.map((_: any) => ({
            headerName: `${_.AttributeName} [${_.KeyType}]`,
            ...columnBuilder(_.AttributeName)
        }))
        this.header.push(...[
            ...schemaHeader,
            ...this.rows
                .flatMap(row => Object.keys(row))
                .filter(this.distinctFilter)
                .filter(key => !schemaHeader.map(_ => _.field).includes(key))
                .sort((a, b) => a.localeCompare(b))
                .map(field => columnBuilder(field))
        ].filter(_ => !this.header.map(column => column.field).includes(_.field)))
    }

    beforeRouteUpdate(to: Route, from: Route, next: () => void): void {
        this.header = []
        this.rows = []
        this.selectedRows = []
        this.highlighter = {}
        this.lastEvaluatedKey = null
        this.tableDescription = null
        this.queryModel = {
            hash: '',
            criteria: {}
        }
        this.editDocument = null
        this.compareDocuments = null

        this.$nextTick(async () => {
            await Promise.all([
                this.loadTableDescription(to.params.profile, to.params.tableName),
                this.loadData(to.params.profile, to.params.tableName, false)
            ])
            this.buildHeader()
            this.gridOptions.api?.setColumnDefs(this.header)
        })
        next()
    }

    async mounted() {
        await Promise.all([
            this.loadTableDescription(this.profile, this.tableName),
            this.loadData(this.profile, this.tableName, false)
        ])
        this.buildHeader()

        this.$nextTick(async () => {
            if (this.gridOptions?.api) {
                this.gridOptions.api.addEventListener('viewportChanged', async (e: ViewportChangedEvent) => {
                    if (!this.loading && this.lastEvaluatedKey && e.lastRow >= 0.9 * this.rows.length) {
                        await this.loadData(this.profile, this.tableName)
                        if (this.gridOptions?.api) {
                            this.gridOptions.api.ensureIndexVisible(e.lastRow)
                        }
                    }
                })
                this.gridOptions.api.addEventListener('rowDoubleClicked', (e: RowDoubleClickedEvent) => {
                    this.editDocument = JSON.parse(JSON.stringify(e.data))
                })

                this.gridOptions.api.addEventListener('selectionChanged', (e: SelectionChangedEvent) => {
                    this.selectedRows = e.api.getSelectedRows()
                })
            }
        })
    }

}
